import { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import logo from '../assets/img/whiskey_rebel_logo.png'; 
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/img/nav-icon4.svg'; // GitHub icon
import { trackServiceInquiry, trackEvent } from '../lib/analytics';

export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [])

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }

    const handleConnectClick = () => {
        trackServiceInquiry('navigation_connect');
        
        const contactSection = document.getElementById('connect');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const handleSocialClick = (platform) => {
        trackEvent('social_click', {
            category: 'social_media',
            label: platform
        });
    };

    return (
        <header>
            <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
                <Container>
                <Navbar.Brand href="#home">
                    <img src={logo} alt="Whiskey Rebel Creative — Home" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <span className="navbar-toggler-icon"></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
                        <Nav.Link href="#systems" className={activeLink === 'systems' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('systems')}>Systems</Nav.Link>
                        <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Work</Nav.Link>
                        <Nav.Link href="#pricing" className={activeLink === 'pricing' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('pricing')}>Pricing</Nav.Link>
                    </Nav>
                    <span className="navbar-text">
                        <div className="social-icon">
                            <a 
                                href="https://www.linkedin.com/in/george-hoffmann" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                aria-label="LinkedIn"
                                onClick={() => handleSocialClick('linkedin')}
                            >
                                <img src={navIcon1} alt="" />
                            </a>
                            <a 
                                href="https://x.com/whiskeyrebelcre" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                aria-label="X"
                                onClick={() => handleSocialClick('twitter')}
                            >
                                <img src={navIcon2} alt="" />
                            </a>
                            <a 
                                href="https://www.instagram.com/whiskeyrebelcreative" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                aria-label="Instagram"
                                onClick={() => handleSocialClick('instagram')}
                            >
                                <img src={navIcon3} alt="" />
                            </a>
                            <a 
                                href="https://github.com/WhiskeyRebel" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                aria-label="GitHub"
                                onClick={() => handleSocialClick('github')}
                            >
                                <img src={navIcon4} alt="" />
                            </a>                         
                        </div>
                        <button className="vvd" onClick={handleConnectClick}><span>Let's Connect</span></button>
                    </span>
                </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}
